import React, { Fragment } from 'react';
import { DetailContent } from './DetailContent';
import { useTvGuideChannel } from '../../../hooks/use-tv-guide-channel';
import { useBottomDialogDispatch } from '../../BottomDialog/BottomDialogContext';
import { LoadingBar } from '../../LoadingBar/LoadingBar';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TvGuideDetail = ({
  selectedProgram,
  date,
  analyticsPageId
}) => {
  const {
    extendedProgram,
    isLoading
  } = useTvGuideChannel(date, selectedProgram.channel);
  const dispatch = useBottomDialogDispatch();
  const extendedSelectedProgram = extendedProgram && extendedProgram.programList.find(program => program.startTime === selectedProgram.program.startTime && program.endTime === selectedProgram.program.endTime);
  const displayedProgram = extendedSelectedProgram ? {
    program: extendedSelectedProgram,
    channel: selectedProgram.channel
  } : selectedProgram;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingBar, {
      isLoading: isLoading
    }), /*#__PURE__*/_jsx(DetailContent, {
      selectedProgram: displayedProgram,
      onClose: () => dispatch({
        type: 'remove-dialog'
      }),
      analyticsPageId: analyticsPageId
    })]
  });
};